import React from "react";
import PropTypes from "prop-types";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/classNames";

const tasteTagVariants = cva("taste-tag", {
  variants: {
    variant: {
      default: "taste-tag--default",
      matched: "taste-tag--matched",
      subtle: "taste-tag--subtle",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const TasteTag = React.forwardRef(
  ({ className, variant, children, ...props }, ref) => (
    <span
      className={cn(tasteTagVariants({ variant, className }))}
      ref={ref}
      {...props}
    >
      {children}
    </span>
  )
);

TasteTag.displayName = "TasteTag";

TasteTag.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(["default", "matched", "subtle"]),
  children: PropTypes.node.isRequired,
};

export { TasteTag, tasteTagVariants };
export default TasteTag;
